import { Loading } from "@/components/atoms";
import { ExternalSupplierDetail } from "../../../common/ExternalSupplierDetail";
import { useAppSelector } from "@/redux/hooks";
import { externalSuppliersFormOptionsSelector } from "@/redux/slices/externalSupplier/selectors";
import { useGetExternalSuppliersFormOptionsQuery } from "@/redux/apis/externalSupplier/externalSupplierApi";

interface TypeFieldProps {
  type: string;
  editMode: boolean;
}

export const TypeField = ({ type, editMode }: TypeFieldProps) => {
  const { isFetching } = useGetExternalSuppliersFormOptionsQuery();
  const { types } = useAppSelector(externalSuppliersFormOptionsSelector);

  return (
    <div className="relative">
      {isFetching && <Loading />}
      <ExternalSupplierDetail
        editMode={editMode}
        label="Type"
        detail={
          // editMode ? (
          //   <div className="flex flex-col gap-1">
          //     <Controller
          //       name="type"
          //       control={control}
          //       render={({ field }) => (
          //         <DropdownSelect
          //           className="w-full"
          //           options={types}
          //           placeholder="Select Type"
          //           value={field.value?.toString()}
          //           onChange={(value) => field.onChange(value)}
          //           hasError={!!formErrors.type}
          //         />
          //       )}
          //     />
          //     <ErrorMessage errors={formErrors} name="type" />
          //   </div>
          // ) : types.find(typeItem => typeItem.value === type)?.name ?? ""
          types.find(typeItem => typeItem.value === type)?.name
        }
      /> 
    </div>
  );
};
